import { render, staticRenderFns } from "./DeleteCommentField.vue?vue&type=template&id=49a5683c&scoped=true&"
import script from "./DeleteCommentField.vue?vue&type=script&lang=ts&"
export * from "./DeleteCommentField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5683c",
  null
  
)

export default component.exports